import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { projectActions } from '@flux/action/projects';
import { ThemeType } from '@model';
import { useHistory, useLocation } from 'react-router-dom';
import { noneProjectSpecificUrl } from '@model/pagePath';

const AllThemeType = [ThemeType.dark, ThemeType.light];

const ThemeClassName = {
  [ThemeType.dark]: 'theme-dark',
  [ThemeType.light]: 'theme-light',
};

function useTheme() {
  const projectTheme = useSelector((state) => state?.projects?.theme);
  const systemTheme = useSelector((state) => state?.common?.systemTheme);
  const location = useLocation();
  const dispatch = useDispatch();
  const outSideProject = noneProjectSpecificUrl.some((i) =>
    (location?.pathname + location?.search).includes(i),
  );
  const theme = outSideProject ? systemTheme : projectTheme;

  const changeProjectTheme = useCallback(
    (nextTheme) => {
      if (!AllThemeType.includes(nextTheme)) {
        throw new Error('Invalid theme name');
      }
      if (theme !== nextTheme) {
        dispatch(projectActions.changeTheme(nextTheme));
      }
    },
    [theme],
  );

  useEffect(() => {
    document.body.className = ThemeClassName[theme];
  }, [theme]);

  return {
    theme,
    changeProjectTheme,
  };
}

export default useTheme;
